import { isPlanDowngrade } from '../../_helpers/subscription-plan';
import { getActiveSubscriptionPlanId } from '../../_helpers/subscription-access';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AuthService } from '../../_services/auth.service';
import { PaymentService } from '../../_services/subscription/payment.service';
import { FormsModule } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { load, Cashfree } from '@cashfreepayments/cashfree-js';
import { environment } from '../../../environments/environment';
import {
  PLANS,
  PaymentPlan,
  SELECTED_PLAN_STORAGE_KEY,
  findPaymentPlan,
  findPlanByQuery,
} from '../payment-plan/payment-plan.component';

const PLAN_SELECTION_ROUTE = '/payment';

const toOrderPlan = (plan: PaymentPlan) => ({
  planName: plan.id.toUpperCase(),
  amount: plan.price,
  duration: plan.billingPeriod.replace(/^\/\s*/, ''),
});

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  selectedPlan: PaymentPlan = PLANS[0];
  plan = toOrderPlan(this.selectedPlan);
  gstNumber: string = '';
  isOutsideBangalore: boolean = false;
  isGstEnabled: boolean = false;
  // gstRate = 0;
  gstRate = 0.18;
  totalSubsriptionAmount: number = 0;
  user: any = {};
  private cashfree: Cashfree | null = null;

  constructor(
    private _AS: AuthService,
    private _SPS: PaymentService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    this.getUserDetails();
    if (isPlatformBrowser(this.platformId)) {
      const selected = this.readSelectedPlan();
      if (!selected || isPlanDowngrade(getActiveSubscriptionPlanId(this._AS.getUser()), selected.id)) {
        this.router.navigate([PLAN_SELECTION_ROUTE], { replaceUrl: true });
        return;
      }
      this.selectedPlan = selected;
      this.plan = toOrderPlan(selected);
      load({ mode: environment.cashfreeMode }).then((cf) => (this.cashfree = cf));
    }
  }
  /** Plan chosen on the plan page: router state first, session copy on refresh. */
  private readSelectedPlan(): PaymentPlan | null {
    const fromQuery = findPlanByQuery(this.route.snapshot.queryParamMap.get('plan'));
    if (fromQuery) return fromQuery;
    const fromState = findPaymentPlan(history.state?.plan?.id);
    if (fromState) return fromState;
    try {
      const stored = sessionStorage.getItem(SELECTED_PLAN_STORAGE_KEY);
      return stored ? findPaymentPlan(JSON.parse(stored)?.id) : null;
    } catch {
      return null;
    }
  }

  get includedFeatureCount(): number {
    return this.selectedPlan.features.filter((feature) => feature.included)
      .length;
  }

  changePlan(): void {
    this.router.navigate([PLAN_SELECTION_ROUTE], { queryParams: { plan: this.selectedPlan.id }, queryParamsHandling: 'merge' });
  }

  goBack(): void {
    this.location.back();
  }
  getUserDetails() {
    this._AS.getUserProfile().subscribe((res: any) => {
      this.user = res;
    });
  }

  get gstAmount(): number {
    return this.plan.amount * this.gstRate;
  }

  get totalAmount(): number {
    return this.plan.amount + this.gstAmount;
  }

  isProcessing = false;
  // makePayment() {
  //   this.isProcessing = true;
  //   const payload = {
  //     ...this.plan,
  //     isOutsideBangalore:this.isOutsideBangalore,
  //     amount: Math.round(this.totalAmount * 100) // paise, original amount untouched
  //   };
  //   this._SPS.subscriptionPymnt(payload).subscribe({
  //     next: (res: any) => {
  //       if (res.url && res.transactionId) {
  //         const subpaymentData = {
  //           ...this.plan,
  //           totalAmount: this.totalAmount,
  //           transactionId: res.transactionId,
  //           isOutsideBangalore:this.isOutsideBangalore
  //         };
  //         localStorage.setItem('subpaymentData', JSON.stringify(subpaymentData));
  //         window.location.href = res.url;
  //       } else {
  //         this.isProcessing = false;
  //       }
  //     },
  //     error: (err) => {
  //       this.isProcessing = false;
  //     }
  //   });
  // }
  makePayment() {
    if (isPlanDowngrade(getActiveSubscriptionPlanId(this._AS.getUser()), this.selectedPlan.id)) {
      this.router.navigate([PLAN_SELECTION_ROUTE], { replaceUrl: true });
      return;
    }
    this.isProcessing = true;

    const staticCustomer = {
      customerId: this.user._id,
      name:  this.user.name,
      email:  this.user.email,
      phone: `${this.user.country.dial}${this.user.phone}`,
    };

    const payload = {
      ...this.plan,
      currency:'INR',
      isOutsideBangalore: this.isOutsideBangalore,
      amount: Math.round(this.totalAmount), // paise
      customer: staticCustomer,
    };

    this._SPS.createOrder(payload).subscribe({
      next: (res: any) => {
        if (res.paymentSessionId && res.orderId && this.cashfree) {
          const subpaymentData = {
            ...this.plan,
            name: this.selectedPlan.name,
            totalAmount: this.totalAmount,
            transactionId: res.orderId,
            isOutsideBangalore: this.isOutsideBangalore,
            customer: staticCustomer,
          };
          localStorage.setItem(
            'subpaymentData',
            JSON.stringify(subpaymentData),
          );

          this.cashfree
            .checkout({
              paymentSessionId: res.paymentSessionId,
              redirectTarget: '_self',
            })
            .then((result) => {
              if (result.error) {
                console.error(result.error);
                this.isProcessing = false;
              }
            });
        } else {
          this.isProcessing = false;
        }
      },
      error: () => {
        this.isProcessing = false;
      },
    });
  }
}
